<template>
  <v-dialog v-model="dialog" width="800">
    <v-card class="pa-10">
      <v-icon x-large class="v-icon-delete">
        mdi-delete-alert-outline
      </v-icon>

      <div v-if="currentCertificationBodyItem">
        <div class="text-h6 pp-center">
          Are you sure you want to delete the Awarding Body of "{{ currentCertificationBodyItem.name }}"?
        </div>

        <p class="pp-center pb-5">
          This Awarding Body will be deleted immediately. You can't undo this action.
        </p>
      </div>

      <div v-else>
        <UnavailableContent />
      </div>

      <Loading v-if="certificationBodyItemLoading"/>

      <ConfirmCancelButtons
          :item="currentCertificationBodyItem"
          :confirm-disabled="certificationBodyItemLoading"
          confirm-text="Delete Awarding Body"
          :confirm-action="deleteItemConfirm"
          cancel-class="mr-5"
          :cancel-action="closeDialog"
      />

    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import ConfirmCancelButtons from "@/components/common/ConfirmCancelButtons";
import Loading from "@/components/common/Loading";
import UnavailableContent from "@/components/common/UnavailableContent";

export default {
  name: "CertificationBodyDelete",
  components: {UnavailableContent, ConfirmCancelButtons, Loading},
  computed: {
    ...mapState(['currentCertificationBodyItem']),
    ...mapGetters([
      'certificationBodyApiError',
      'openDialog',
      'currentCertificationBodyItem',
      'certificationBodyItemLoading',
    ]),
    dialog: {
      get () {
        return this.openDialog === 'certificationBodyDelete';
      },
      set(value) {
        this.setOpenDialog(value);
      },
    },
  },
  methods: {
    ...mapActions(['deleteCertificationBody', 'clearCertificationBodyItems', 'setOpenDialog', 'closeOpenDialog']),
    closeDialog() {
      this.closeOpenDialog();
      this.clearCertificationBodyItems();
    },
    async deleteItemConfirm() {
      const deleted = await this.deleteCertificationBody(this.currentCertificationBodyItem);
      if (deleted) {
        this.closeOpenDialog();
      }
    },
  },
};
</script>
